import { useCallback, useRef, useState } from "react";
import { useProjectScorecardPanelStyles } from "../ProjectScorecardPanel.styles";

export interface IHtmlPreviewProps {
  html: string;
  disableScroll?: boolean;
}

export const HtmlPreview = ({
  html,
  disableScroll,
}: IHtmlPreviewProps): JSX.Element => {
  const styles = useProjectScorecardPanelStyles();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [autoHeight, setAutoHeight] = useState<number | null>(null);

  const handleLoad = useCallback(() => {
    if (!disableScroll) return;
    const contentDocument = iframeRef.current?.contentDocument;
    if (!contentDocument) return;
    setAutoHeight(contentDocument.documentElement.scrollHeight);
  }, [disableScroll]);

  return (
    <iframe
      ref={iframeRef}
      // allow-same-origin is scoped to disableScroll (Retrospective Case
      // Study only) because measuring contentDocument.scrollHeight requires
      // same-origin access. allow-scripts stays absent, so the uploaded HTML
      // cannot execute code or escalate via document.domain — the accepted
      // residual risk is CSS-based network requests / phishing-style content
      // from the uploaded file, acceptable since uploaders are authenticated
      // workspace members, not anonymous third parties.
      sandbox={disableScroll ? "allow-same-origin" : ""}
      referrerPolicy="no-referrer"
      srcDoc={html}
      title="Project Scorecard"
      className={disableScroll ? styles.iframeNoScroll : styles.iframe}
      scrolling={disableScroll ? "no" : undefined}
      onLoad={handleLoad}
      style={disableScroll && autoHeight ? { height: autoHeight } : undefined}
    />
  );
};
